import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { fmtCurrency, fmtDate } from "@/lib/format";

export const FILTER_KEYS = ["period", "company_id", "owner_id", "technician_id", "status", "category", "product_id", "priority", "type", "origin"];

export const SECTION_LABEL = { overview: "Panoramica", sales: "Commerciale", activities: "Attività", interventions: "Interventi e SLA",
  reports: "Rapportini e pacchetti", billing: "Da fatturare", contracts: "Contratti e canoni", customers: "Clienti" };

const num = new Intl.NumberFormat("it-IT", { maximumFractionDigits: 2 });

// ore decimali -> H,MM (regola globale ON!)
const hm = (h) => { const m = Math.round((h || 0) * 60); return `${Math.floor(m / 60)},${String(m % 60).padStart(2, "0")}`; };

export const moneyHeader = (c) => (c.type === "money" && !/imponibile|iva/i.test(c.label) ? `${c.label} (imponibile)` : c.label);

export const fmtValue = (v, type) => {
  if (v === null || v === undefined || v === "") return "—";
  switch (type) {
    case "money": return fmtCurrency(v);
    case "pct": return `${num.format(v)}%`;
    case "date": return fmtDate(v);
    case "hours": return hm(v);
    case "minutes": return `${hm(v / 60)} h`;
    case "days": return `${v} gg`;
    case "int": case "num": return num.format(v);
    default: return String(v).replace(/_/g, " ");
  }
};

export const cleanParams = (o) => Object.fromEntries(Object.entries(o).filter(([, v]) => v !== null && v !== undefined && v !== ""));

export const downloadExport = async (params, label) => {
  try {
    const r = await api.get("/analytics/export", { params: cleanParams(params), responseType: "blob", timeout: 90000 });
    const name = (r.headers["content-disposition"] || "").match(/filename="(.+)"/)?.[1] || `${label}.${params.format}`;
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a"); a.href = url; a.download = name; a.click();
    setTimeout(() => URL.revokeObjectURL(url), 3000);
  } catch (e) { toast.error(errorMessage(e)); }
};
